import React, { useEffect, useState } from 'react'
import { HeaderTable } from '../../HeaderTable'
import DataTable from 'react-data-table-component'
import Pagination from '../../ui/Pagination'
import axios from 'axios'
import MembershipTable from './copys/MembershipTable'
import MemberShipFilter from './MemberShipFilter'
import ModleAddMemberShip from './ModleAddMemberShip'
const GET_LIST_Filter = 'admin/qualification/before_filter_Qualification_day'
const GET_URL = 'admin/qualification/get_all_members_sub'

const Membership = () => {
    const [modalIsOpen, setModalIsOpen] = useState("");
    const [fetchData, setFetchData] = useState([])
    
  const [loading, setloading] = useState(true)
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1)
const [dataFillter, setDataFillter] = useState({
   "memberNumber": "",
  })
  // const [datafiler, setDatafiler] = useState([]);

  // const getDFilter = async () => {

  //   await axios.get(GET_LIST_Filter, {
  //   })
  //     .then(response => {
  //       setDatafiler(response?.data)

  //     })

  // }
  // useEffect(() => {
  //   getDFilter()
  // }, [])


  const handleColse = () => {
    setModalIsOpen("")
  }
    const getMemberships = async (page) => {
      setloading(true);
        await axios.get(GET_URL, {
            params: {
                ...dataFillter,
                "page": page
                , "size": perPage,
                // "sortName": "startDate",


            }
        })
            .then(response => {
                setFetchData(response?.data?.content)
                // setTotalRows(1);
                setTotalRows(response?.data?.totalPages);
            })
        setloading(false)

    }
    const handlePageChange = (page) => {
        // fetchUsers(page);
        getMemberships(page-1);
        setCurrentPage(page);
      };
 useEffect(() => {
        getMemberships(currentPage-1)
    }, [currentPage,perPage,dataFillter])
    return (
        <div className='w-full  p-3'>
            <MemberShipFilter
        // datafiler={datafiler}
        setDataFillterout={(filter)=>{setDataFillter(filter)
          setCurrentPage(1)
        }}
      />
            <HeaderTable active={"חברי לשכה"}
                setModalIsOpen={setModalIsOpen} 
                // downloadExcel={downloadExcel} howmach={fetchData?.length}
            />
           <MembershipTable members={fetchData} loading={loading} /> 
            {/* <DataTable
              columns={columns} data={fetchData}
                //   pagination
                customStyles={customStyles}
                paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            conditionalRowStyles={conditionalRowStyles} // העברת הסגנון המותנה
            progressPending={loading} className='border'
            /> */}
            {/* </DataTable> */}
            <Pagination currentPage={currentPage} totalPages={totalRows} onPageChange={handlePageChange} />
      {modalIsOpen == "New" && <ModleAddMemberShip showModal={modalIsOpen == "New"} handleColse={handleColse}  getDataTable={getMemberships}> </ModleAddMemberShip>}
            {/* {modalIsOpen == "New" && <ModalNewTrainingDays showModal={modalIsOpen == "New"} handleColse={handleColse} getDepartment={getTrainingDays} getDFilter={getDFilter}>
      </ModalNewTrainingDays>}
      {modalIsOpen == "Edit" && <ModalNewTrainingDays showModal={modalIsOpen == "Edit"} handleColse={handleColse} getDepartment={getTrainingDays} getDFilter={getDFilter} row={id}>
      </ModalNewTrainingDays>}
      {modalIsOpen == "Delete" && <ModalEdit showModal={modalIsOpen == "Delete"} handleColse={handleColse} handleDetele={handleDetele}></ModalEdit>}
      {modalIsOpen == "MoreOptions" && <MoreOptions handleColse={handleColse} row={id}></MoreOptions>} */}

        </div>
    )
}

export default Membership